import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COUNTERPARTIES_ITEM: {},
  COUNTERPARTIES_LIST: [],
  COUNTERPARTIES_TABLE_DATA: [],
  COUNTERPARTIES_ARRAY_DATA: [],
  COUNTERPARTIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_COUNTERPARTIES_ITEM: (state) => {
    return state.COUNTERPARTIES_ITEM;
  },
  GET_COUNTERPARTIES_LIST: (state) => {
    return state.COUNTERPARTIES_LIST;
  },
  GET_COUNTERPARTIES_TABLE_DATA: (state) => {
    return state.COUNTERPARTIES_TABLE_DATA;
  },
  GET_COUNTERPARTIES_ARRAY_DATA: (state) => {
    return state.COUNTERPARTIES_ARRAY_DATA;
  },
  GET_COUNTERPARTIES_TOTAL_ROWS: (state) => {
    return state.COUNTERPARTIES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_COUNTERPARTIES_ITEM(state, item) {
    state.COUNTERPARTIES_ITEM = item;
  },

  UPDATE_COUNTERPARTIES_LIST(state, list) {
    
    state.COUNTERPARTIES_LIST = list.data;

    state.COUNTERPARTIES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.COUNTERPARTIES_TABLE_DATA = [];
    state.COUNTERPARTIES_ARRAY_DATA = [];

    list.forEach(el => {

      state.COUNTERPARTIES_TABLE_DATA.push({
        'uuid'    : el.uuid,
        'id'      : el.id,
        'name'    : el.name,
        'type'    : el.type,
        'inn'     : el.inn,
        'kpp'     : el.kpp,
        'address' : el.address,
        'comments': el.comments,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,        
        'registration_address': el.registration_address,
        'phone': el.phone,
      });

      state.COUNTERPARTIES_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_COUNTERPARTIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/counterparties/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COUNTERPARTIES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_COUNTERPARTIES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/counterparties';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COUNTERPARTIES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_COUNTERPARTIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/counterparties';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COUNTERPARTIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/counterparties/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COUNTERPARTIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/counterparties/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}